declare global {
    interface Window {
        appConfig: {
            apiEndpoint: string;
            authenticationApiEndpoint?: string;
            localization?: string;
            product?: string;
        }
    }
}

export const APP_CONFIG = {
    get API_ENDPOINT(): URL | string {
        const endpoint = window.appConfig?.apiEndpoint || '';
        try {
            return new URL(endpoint);
        } catch {
            // If it's a relative path or invalid URL, return as string
            return endpoint;
        }
    },

    get AUTH_API_ENDPOINT(): URL | string {
        const endpoint = window.appConfig?.authenticationApiEndpoint || window.appConfig?.apiEndpoint || '';
        try {
            return new URL(endpoint);
        } catch {
            // If it's a relative path or invalid URL, return as string
            return endpoint;
        }
    },

    get LOCALIZATION(): string {
        return window.appConfig?.localization || 'EE';
    },

    get PRODUCT(): string {
        return window.appConfig?.product || 'PALK';
    },
} as const;

/**
 * Supported languages in the application
 */
export const SUPPORTED_LANGUAGES = ['et', 'en', 'ru'] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

/**
 * Supported culture codes
 */
export const SUPPORTED_CULTURES = ['et-EE', 'en-IE', 'ru-RU'] as const;
export type SupportedCulture = typeof SUPPORTED_CULTURES[number];

